/** Countries that currently have (or can host) a Sports Office. */
export const OFFICE_COUNTRIES = [
  'Belgium',
  'Curacao',
  'Dominica Republic',
  'Ireland',
  'Netherlands',
  'Portugal',
  'Scotland',
  'South Africa',
  'United Kingdom',
  'Zimbabwe',
] as const;

export type OfficeCountry = (typeof OFFICE_COUNTRIES)[number];
